import { transformEnumToDisplay } from '@fruitful/member-profile';
import type { ColumnEditorOptions } from 'primereact/column';

import { DropdownEditor } from '../../../common/components/GridCellEditors';
import { EmploymentStatus } from '../../../entities/entityTypes';

export const EmploymentStatusEditor = (options: ColumnEditorOptions) => {
    const employmentStatuses = Object.values(EmploymentStatus).map(
        (employmentStatus) => ({
            label: transformEnumToDisplay(employmentStatus),
            value: employmentStatus,
        }),
    );

    return (
        <DropdownEditor
            options={options}
            dropdownProps={{
                options: employmentStatuses,
                placeholder: 'Select Employment Status',
            }}
        />
    );
};
